import React from "react";
import { Group, Loader, Paper, Tabs, Text } from "@mantine/core";
import EmailHistory from "@/components/Tax Pro Only/EmailHistory/EmailHistory";
import TaxInfo from "./TaxInfo/TaxInfo";
import { useProfileStore } from "../store/profileStore";
import { useAuthStore } from "@/utils/stores/authStore";

const ProfileContent: React.FC = () => {
  const { user } = useAuthStore();
  const isClient = user?.role === "client";
  const { refresh, setActiveTab, activeTab, tabLoading } = useProfileStore();

  const { sidebarCollapsed, setSidebarCollapsed } = useProfileStore();

  const handleCloseTaxInfoSidebar = () => {
    if (activeTab === "taxinfo") {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const renderTabLabel = (
    label: string,
    value: string,
    extra?: React.ReactNode
  ) => (
    <Group gap={6}>
      <Text>{label}</Text>
      {tabLoading && activeTab === value && <Loader size="xs" />}
      {extra}
    </Group>
  );

  return (
    <Tabs
      color="#0077CC"
      defaultValue="taxinfo"
      value={activeTab}
      onChange={(value) => {
        setActiveTab(value);
      }}
    >
      <Tabs.List style={{ paddingLeft: "1.25rem" }}>
        <Tabs.Tab onClick={handleCloseTaxInfoSidebar} value="taxinfo">
          {renderTabLabel("Tax Information", "taxinfo")}
        </Tabs.Tab>
        {!isClient && (
          <Tabs.Tab value="email">
            {renderTabLabel("Email Overview", "email")}
          </Tabs.Tab>
        )}
      </Tabs.List>

      <Tabs.Panel value="taxinfo">
        <TaxInfo />
      </Tabs.Panel>

      {!isClient && (
        <Tabs.Panel
          pt="3.12rem"
          pl="5.5rem"
          pr="5.5rem"
          pb="1rem"
          value="email"
          p={"md"}
        >
          <Paper shadow="xs" p="md" withBorder>
            <EmailHistory refresh={refresh} />
          </Paper>
        </Tabs.Panel>
      )}
    </Tabs>
  );
};

export default ProfileContent;
